import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthApiService } from '@app/modules/auth/services/auth-api/auth-api.service';
import { IUserStats } from '@app/modules/auth/interfaces/user-stats.interface';

/**
 * Interceptor that watches all responses for X-Used-Credits header
 * and updates cached user session accordingly.
 */
@Injectable()
export class CreditsInterceptor implements HttpInterceptor {
    constructor(private readonly authService: AuthApiService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            tap((event: HttpEvent<unknown>) => {
                if (event instanceof HttpResponse) {
                    const usedCreditsHeader = event.headers.get('X-Used-Credits');
                    const statsUpdatedHeader = event.headers.get('X-Updated-Stats');
                    const freeSessionsUsedHeader = event.headers.get('X-Free-Sessions-Used');

                    if (freeSessionsUsedHeader != null) {
                        const freeSessionsUsed = Number(freeSessionsUsedHeader);
                        if (!Number.isNaN(freeSessionsUsed)) {
                            this.authService.updateFreeSessionsUsed(freeSessionsUsed);
                        }
                    }

                    if (usedCreditsHeader != null) {
                        const usedCredits = Number(usedCreditsHeader);
                        if (!Number.isNaN(usedCredits)) {
                            this.authService.updateUsedCredits(usedCredits);
                        }
                    }

                    if (statsUpdatedHeader != null) {
                        const statsUpdated = JSON.parse(statsUpdatedHeader) as IUserStats;
                        if (statsUpdated != null) {
                            this.authService.updateStats(statsUpdated);
                        }
                    }
                }
            })
        );
    }
}
